import Link from "next/link";
import { useMemo, useState } from "react";
import NavPagesDropdown from "@/components/header/navbar/dropdown/nav-pages-dropdown";
import { menu_data, menu_data_2, secondary_menu_data } from "@/data/menu-data";
import { getLocalizedPath, ifArabic } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

export default function OffcanvasMenu({
  type = "navigation",
  onHandleOffCanvas,
  headerTwo = false,
}: {
  type?: string;
  onHandleOffCanvas: () => void;
  headerTwo?: boolean;
}) {
  const { language } = useLanguage();
  const [navTitle, setNavTitle] = useState("");
  //openMobileMenu
  const openMobileMenu = (menu: string) => {
    if (navTitle === menu) {
      setNavTitle("");
    } else {
      setNavTitle(menu);
    }
    onHandleOffCanvas();
  };

  const nav_data = useMemo(
    () => (type == "portals" ? menu_data_2 : menu_data),
    [type]
  );

  const data = useMemo(() => {
    return headerTwo ? secondary_menu_data : nav_data;
  }, [headerTwo]);

  return (
    <div className="tp-main-menu-mobile d-xl-none">
      <nav className="tp-main-menu-content">
        <ul>
          {data.map((menu, index) => (
            <li
              key={menu.id + index}
              className={`${menu.noDropdown ? "" : "has-dropdown"} ${
                menu.home_dropdown || menu.pages_dropdown ? "tp-static" : ""
              } ${navTitle === menu.title ? "dropdown-opened expanded" : ""}`}
            >
              <Link
                aria-label={menu.title || "Menu Link"}
                href={
                  type == "portals"
                    ? menu.link
                    : getLocalizedPath(menu.link ?? "#", language)
                }
                onClick={() => openMobileMenu(menu.title)}
                className={`${
                  menu.home_dropdown || menu.pages_dropdown ? "tp-static" : ""
                }`}
                {...(type === "portals"
                  ? { target: "_blank", rel: "noopener noreferrer nofollow" }
                  : {})}
              >
                {ifArabic(menu.titleAr, menu.title)}{" "}
                <button
                  aria-label="Dropdown Toggle"
                  onClick={() => openMobileMenu(menu.title)}
                  className={`dropdown-toggle-btn ${
                    navTitle === menu.title ? "dropdown-opened" : ""
                  }`}
                ></button>
              </Link>

              {/* {menu.home_dropdown && (
                <div
                  className="tp-megamenu-main"
                  style={{
                    display: navTitle === menu.title ? "block" : "none",
                  }}
                >
                  <NavHomeDropdown home_dropdown={menu.home_dropdown} />
                </div>
              )} */}

              {menu.pages_dropdown && menu?.academics && (
                <div
                  className="tp-megamenu-main"
                  style={{
                    display: navTitle === menu.title ? "block" : "none",
                  }}
                >
                  <NavPagesDropdown
                    pages_dropdown={menu.pages_dropdown}
                    onHandleOffCanvas={onHandleOffCanvas}
                  />
                </div>
              )}

              {menu.sm_mega_menus && !menu?.academics && (
                <ul
                  className="tp-submenu"
                  style={{
                    display: navTitle === menu.title ? "block" : "none",
                  }}
                >
                  {menu.sm_mega_menus.map((dm) => (
                    <li key={dm.id}>
                      <Link
                        aria-label={menu.title || "Menu Link"}
                        href={getLocalizedPath(dm.link ?? "#", language)}
                        onClick={onHandleOffCanvas}
                      >
                        {ifArabic(dm.titleAr, dm.title)}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}

              {menu.pages_dropdown && !menu?.academics && (
                <div
                  className="tp-megamenu-main"
                  style={{
                    display: navTitle === menu.title ? "block" : "none",
                  }}
                >
                  <NavPagesDropdown
                    pages_dropdown={menu.pages_dropdown}
                    onHandleOffCanvas={onHandleOffCanvas}
                  />
                </div>
              )}

              {menu.dropdown_menus && (
                <ul
                  className="tp-submenu"
                  style={{
                    display: navTitle === menu.title ? "block" : "none",
                  }}
                >
                  {menu.dropdown_menus.map((dm) => (
                    <li key={dm.id}>
                      <Link
                        aria-label={menu.title || "Menu Link"}
                        href={getLocalizedPath(dm.link || "#", language)}
                        onClick={onHandleOffCanvas}
                      >
                        {ifArabic(dm.titleAr, dm.title)}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
